<app-auth-navbar></app-auth-navbar>

<main class="rtl">
  <div class="relative py-16 flex content-center items-center justify-center min-h-screen-50">
    <div class="absolute top-0 w-full h-full bg-center bg-cover">
        <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
    </div>
    <div class="container relative mx-auto">
        <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                <div class="">
                    <h2 class="text-white font-semibold text-4xl leading-normal">
                      مجله سلامت
                    </h2>
                    <div class="relative flex w-full flex-wrap items-stretch mt-12">

                      <input type="text" placeholder=" جستجو ... " [(ngModel)]="searchTitle" (keyup.enter)="getBlogList(1)"
                          class="border-0 p-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full">
                      <button type="submit" (click)="getBlogList(1)"
                          class="absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-gray-100 font-medium rounded-lg text-sm p-1 left-0">
                          <img src="../../../assets/img/icon/Search_light.svg" class="w-10" alt="">
                      </button>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>

  <section class="py-16 main-bg">
    <div class="container mx-auto p-4">
      <!-- <div class="flex flex-wrap justify-center text-center mb-4">
        <div class="w-full lg:w-6/12 p-4">
          <h3 class="text-4xl font-semibold"> مجله سلامت </h3>
          
        </div>
      </div> -->
      <div class="flex flex-wrap">
        <div *ngFor="let blog of blogList" class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <img alt="..." [src]="blog.img?apiService.api+blog.img:'../../../assets/img/default-profile.png'" class="shadow-lg w-full h-180-px rounded" />
            <div class="pt-6">
              <h5 class="font-bold min-h-12"> {{blog.title}} </h5>
              
              <div class="flex justify-between">
                <p class="my-2 text-sm text-blueGray-400 font-semibold">
                  {{blog.authorPost}}
                </p> 
                <div class="flex">
                  <img class="w-8 p-1" src="../../../assets/img/icon/calendar_ion.svg" alt=""> <span
                  class="text-gray-500 pt-1"> {{blog.createDate | shamsiDate}} </span>
                </div>
                
              </div>
              <p class="mt-1 text-sm min-h-16">
                {{blog.description}}
              </p>
              <div class="mt-6 flex justify-between">
                <button [routerLink]="'/blog-detail/'+blog.id" type="button"
                  class="bg-primary text-white w-full h-8 rounded outline-none focus:outline-none mb-1"> 
                  ادامه مطلب
                </button>       
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <p-paginator dir="rtl" (onPageChange)="getBlogList($event.page+1)" [first]="first" [rows]="rows"
          [totalRecords]="collectionSize" [showCurrentPageReport]="true" [showPageLinks]="false"
          [showJumpToPageDropdown]="false" currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} مقاله" />
    </div>
    </div>
  </section>
  
</main>
<app-footer></app-footer>